import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IRetailerLinkCohortEnum) {
    (function(RetailerLinkCohort) {
        RetailerLinkCohort["RETAILER_LINK_COHORT_UNKNOWN"] = "RETAILER_LINK_COHORT_UNKNOWN";
        /**
     * Retailers who have never linked their POS or have churned after the new experience launched
     */ RetailerLinkCohort["NEW"] = "NEW";
        /**
     * Retailers who unlinked their POS before the new experience launched
     */ RetailerLinkCohort["CHURNED"] = "CHURNED";
        /**
     * Linked retailers who haven't linked items since the new experience launched
     */ RetailerLinkCohort["INACTIVE"] = "INACTIVE";
        /**
     * Linked retailers who have linked items since the new experience launched
     */ RetailerLinkCohort["ACTIVE"] = "ACTIVE";
    })(IRetailerLinkCohortEnum.RetailerLinkCohort || (IRetailerLinkCohortEnum.RetailerLinkCohort = {}));
    IRetailerLinkCohortEnum.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IRetailerLinkCohortEnum || (IRetailerLinkCohortEnum = {}));
export var IRetailerLinkCohortEnum;
